import React, { useEffect, useState } from "react";
import classNames from 'classnames';
import { ToastContainer } from "react-toastify";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import "react-toastify/dist/ReactToastify.css";
import {
  getMerchantAddress,
  getMerchantSetting,
  getMerchantPages,
} from "apiServices/app";
import { CryptoPassword, encryptedText } from "utils/crypto";
import { EcommerceFlow, toastMessage, useGlobalMerchant } from 'utils/helper';
import ECProductComponent from "components/Ecommerce/ECProductComponent";
import ECHeroSectionComponent from "components/Ecommerce/ECTheme/ECBasic/ECHeroSectionComponent";
import ECAddressWrapperComponent from '../../ECAddressWrapperComponent';
import ECHeaderComponent from '../../ECLayout/ECHeaderComponent';
import ECFooterComponent from '../../ECLayout/ECFooterComponent';
import { useBasket } from "containers/POSContainer/constant";
import { useStyles } from '../../ECAdvance/ECAdvanceComponent/style';

const ECBasicComponent = () => {
  const classes = useStyles();
  const { globalMerchantId, ecommerceContent, isEndsWithSlash } = useGlobalMerchant();
  const [showProducts, setShowProducts] = useState(false);
  const [showShippingLayout, setShowShippingLayout] = useState(false);
  const [showSideBasket, setShowSideBasket] = useState(false);
  const [pagesContent, setPagesContent] = useState<any>({});
  const [merchantContent, setMerchantContent] = useState<any>({});
  const [chainList, setChainList] = useState<any>([]);

  const itemlist = useBasket();

  let length = 0;
  if (itemlist && itemlist.itemList) { length = itemlist.itemList.length; }

  const onGetMerchantAddress = (getMerchantId: any) => {
    try {
      getMerchantAddress(getMerchantId)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData.length > 0) {
            const activeNetworks = responseData.filter((network: any) => network.is_active === 1);
            setChainList(activeNetworks.reverse());
          } else {
            toastMessage("You don't have blockchain profile");
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  };

  const onGetMerchantPages = (getMerchantKey: any) => {
    try {
      getMerchantPages(getMerchantKey)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            setPagesContent(responseData);
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  }

  const onGetMerchantDetails = (getUserKey: any) => {
    try {
      getMerchantSetting(getUserKey)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            if (responseData && responseData.success == false) {
              toastMessage("You dont have any profile");
            } else {
              onGetMerchantPages(responseData.merchant_id);
              onGetMerchantAddress(responseData.merchant_id);
              setMerchantContent(responseData);
              localStorage.setItem("ec-email", encryptedText(CryptoPassword, responseData.merchant_email));
            }
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  };

  useEffect(() => { onGetMerchantDetails(globalMerchantId); }, []);

  useEffect(() => {
    const getPathname = window.location.pathname
    getPathname === '/order' && setShowProducts(true)
  }, [])

  return (
    <>
      {Object.keys(merchantContent).length == 0 ? (
        <div className="loaderCenterWrapper">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      ) : (
        <div className={classNames(classes.ecWrapper)}>
          <div className={showProducts ? "ec-component-wrapper inner" : "ec-component-wrapper"}>
            <ToastContainer />
            <ECHeaderComponent
              merchantContent={merchantContent}
              chainList={chainList}
              showShippingLayout={showShippingLayout}
              showSideBasket={showSideBasket}
              setShowSideBasket={setShowSideBasket}
              setShowShippingLayout={setShowShippingLayout}
              isEndsWithSlash={isEndsWithSlash}
              pagesContent={pagesContent}
            />
            <div className="mainPage ecProduct">
              {showShippingLayout && <ECAddressWrapperComponent flowName={EcommerceFlow} setShowShippingLayout={setShowShippingLayout} />}
              {!showShippingLayout && (
                <>
                  {showProducts && <ECProductComponent />}
                  {!showProducts && <ECHeroSectionComponent setShowProducts={setShowProducts} ecommerceContent={ecommerceContent} />}
                </>
              )}
            </div>
            <ECFooterComponent />
          </div>
        </div>
      )}
    </>
  );
};

export default ECBasicComponent;
